import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../asset/logo.png";
import axios from "axios";
import { API_URL, categoryapi } from "../../../constant";
// import {useGetPackageTypeQuery}
const Navbar = () => {
  const [categories, setCategries] = useState("");

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${API_URL}${categoryapi}`);
        setCategries(response?.data?.data);
      } catch (error) {
        // console.error("Error fetching Packages", error);
      }
    };
    fetchPackages();
  }, []);
  return (
    <>
      <nav className=" navbar navbar-expand-lg position-absolute top-0 w-100 z-3">
        <div className="container d-flex justify-content-between">
          <NavLink to="/">
            <img src={logo} alt="" width={140} />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 d-flex justify-content-lg-end w-100">
              <li className="nav-item">
                <NavLink to="/" className="nav-link fw-medium">
                  Home
                </NavLink>
              </li>

              <li className="nav-item">
</li>
{categories?.length > 0 ? (
  categories.map((pkg) => (
    <li key={pkg.name} className="nav-item">
      <NavLink className="nav-link" to={`/packages/${pkg._id}`}>
        {pkg.name} Packages
      </NavLink>
    </li>
  ))
) : (
""
)}

              {/* <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle fw-medium"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Packages
                </Link>

 <ul className="dropdown-menu ps-3">
                  {categories.length > 0 ? (
                    categories.map((pkg, index) => (
                      <li key={pkg._id || index} className="mb-2">
                        <NavLink
                          className="dropdown-item bg-transparent nav-item nav-link p-0"
                          to={`/packages/${pkg?._id}`}>{pkg.name}</NavLink>
                      </li>
                    ))
                  ) : (
                    <li>No Package Type Available</li>
                  )}
                </ul>
              </li> */}
              <li>
                <NavLink to="/destination" className="nav-link fw-medium">
                  Destination
                </NavLink>
              </li>
              <li>
                <NavLink to="/theme" className="nav-link fw-medium">
                  Theme
                </NavLink>
              </li>
              <li>
                <NavLink to="/blogs" className="nav-link fw-medium">
                  Blog
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" className="nav-link fw-medium">
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
